import {AiEnhanceModal} from '#components';

export function useAIActions() {
  function openEnhanceModal({text, context}) {
    return new Promise(async resolve => {

      const modal = useFModal({
        id: 'ai-enhance-modal',
        size: 'xl',
        clickToClose: false,
        showClose: false,
        component: AiEnhanceModal,
        props: {
          text,
          context
        },
        eventHandlers: {
          accept(response) {
            resolve(response);
            modal.close();
          }
        }
      });

      modal.open();
    });

  }
  return {
    openEnhanceModal
  };
}
